import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import { Checkbox } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { isEmpty, isArray, isNull } from 'lodash';
import moment from 'moment';
import qs from 'querystring';
import * as Yup from 'yup';

import { Report } from '~/components';
import {
  DateTime,
  Autocomplete,
  Input,
  RadioGroup,
  MultiAutocomplete,
} from '~/components/Form';
import { MODULO_20_GRAUS } from '~/constants/modules';
import { t, can } from '~/helpers';
import api from '~/services/api';

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
});

function Relresumoturno() {
  const [open, setOpen] = useState(true);
  const [selected, setSelected] = React.useState(null); // Nenhum turno selecionado
  const [postoselecionado, setPostoselecionado] = React.useState(); // Nenhum posto selecionado
  const start = moment().set({ hour: 0, minute: 0, second: 0 }); // Dia de hoje
  const [dataselecionada, setDataselecionada] = React.useState(
    start.format('DD/MM/YYYY HH:mm:ss')
  ); // Data selecionada
  const [turnos, setTurnos] = React.useState([]); // Nenhum turno recebido

  const { client } = useSelector((state) => state.user.profile);

  const classes = useStyles();

  const handleClick = (idturno) => {
    if (selected === idturno) setSelected(null);
    else setSelected(idturno);
  };

  function handleSerializeForm(params) {
    const idPosto =
      postoselecionado.idposto === null ? '' : postoselecionado.idposto;
    const idTurno = selected === null ? '' : selected;

    return {
      ...params,
      idposto: idPosto,
      idcliente: client,
      idturno: idTurno,
    };
  }

  // Request API turnos
  const getTurnosOLD = React.useCallback(async (params) => {
    try {
      const { data } = await api.post('/turnos/resumoturno', params);

      setTurnos(
        data.map((item) => ({
          idturno: item.idturno,
          numeroturno: item.numeroturno,
          horainicioturno: item.horaturno,
        }))
      );
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    }
  }, []);

  const getTurnos = React.useCallback(async (params) => {
    try {
      const { data } = await api.get('/turnos/resumoturnonovo', {
        params: {
          idposto: params.idposto,
          idcliente: client,
          dataturno: params.dataturno,
          pesquisalista: params.pesquisalista,
        },
        paramsSerializer: (q) => qs.stringify(q),
      });

      setTurnos(
        data.map((item) => ({
          idturno: item.idturno,
          numeroturno: item.numeroturno,
          horainicioturno: item.horaturno,
        }))
      );
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    }
  }, []);

  React.useEffect(() => {
    if (!isEmpty(postoselecionado) && !isEmpty(dataselecionada)) {
      getTurnos({
        idposto: postoselecionado.idposto,
        dataturno: dataselecionada,
        pesquisalista: true,
      });
    }
  }, [postoselecionado, dataselecionada]);

  async function handleValidate(param) {
    try {
      const schema = Yup.object().shape({
        turno: isNull(selected)
          ? Yup.string().required(t('s.relatorio.resumoturno.selecioneturno'))
          : Yup.string().nullable(),
        unidadecomboio: Yup.string()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .nullable(),
      });

      await schema.validate(param, {
        abortEarly: false,
      });
    } catch (err) {
      const form = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          form[error.path] = error.message.replace(`${error.path} `, '');
        });

        if (form.turno) toast.error(form.turno);

        throw { form };
      }
    }
  }

  return (
    <Report
      open={open}
      onClose={() => setOpen(false)}
      title={t('s.relatorio.resumoturno')}
      relatorio="resumoturno"
      serialize={(param) => handleSerializeForm(param)}
      validate={(param) => handleValidate(param)}
      initials={{
        datahorainicial: start.format('DD/MM/YYYY HH:mm:ss'),
        datahorafinal: start.format('DD/MM/YYYY HH:mm:ss'),
      }}
    >
      <DateTime
        label={t('s.geral.opcoes.datahorainicial')}
        name="datahorainicial"
        getValue={(value) => setDataselecionada(value)}
      />

      {/* <MultiAutocomplete
        multiple
        name="unidadecomboio"
        label="codigonomeposto"
        url="postos"
        unique="idposto"
        title={t('s.menu.configuracao.posto')}
        hiddens={[{ name: 'idposto' }, { name: 'nomeposto' }]}
        getValue={(value) => {
          setPostoselecionado(value);
        }}
      /> */}

      <Autocomplete
        name="unidadecomboio"
        label="codigonomeposto"
        url="postos"
        unique="idposto"
        title={t('s.menu.configuracao.posto')}
        defaultValue=""
        hiddens={[{ name: 'idposto' }, { name: 'nomeposto' }]}
        getValue={(value) => {
          setPostoselecionado(value);
        }}
      />

      <TableContainer component={Paper}>
        <Table size="small" aria-label="a dense table">
          <TableHead>
            <TableRow>
              <TableCell align="center">
                {t('s.relatorio.resumoturno.selecao')}
              </TableCell>
              <TableCell align="center">{t('s.menu.operacao.turno')}</TableCell>
              <TableCell align="center">
                {t('s.relatorio.vazaonaoautorizadalistagem.inicio')}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {turnos.map((turno, key) => (
              <TableRow
                hover
                onClick={() => handleClick(turno.idturno)}
                role="checkbox"
                tabIndex={-1}
                key={turno.idturno}
                selected={turno.idturno === selected}
              >
                <TableCell padding="checkbox">
                  <Checkbox
                    checked={turno.idturno === selected}
                    onClick={() => handleClick(turno.idturno)}
                  />
                </TableCell>
                <TableCell align="center">{turno.numeroturno}</TableCell>
                <TableCell align="center">{turno.horainicioturno}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* <RadioGroup
        name="tipo"
        label={t('s.configuracao.produto.tipoproduto')}
        options={[
          { label: t('s.relatorio.geral.manifestado'), value: 'Manifestado' },
          { label: t('s.relatorio.geral.recebido'), value: 'Recebido' },
        ]}
        defaultValue="Recebido"
        serialize={(value) => value}
        row
      /> */}

      {can(MODULO_20_GRAUS) && (
        <RadioGroup
          name="tiporelatorio"
          label={t('s.relatorio.geral.tiporelatorio')}
          options={[
            {
              label: t('s.relatorio.geral.ambiente'),
              value: 'ambiente',
            },
            {
              label: t('s.relatorio.geral.20graus'),
              value: '20graus',
            },
          ]}
          defaultValue="ambiente"
          serialize={(value) => value}
          row
        />
      )}

      <RadioGroup
        name="formato"
        label={t('s.relatorio.geral.formato')}
        options={[
          { label: 'PDF', value: 'pdf' },
          { label: 'Excel', value: 'excel' },
        ]}
        defaultValue="pdf"
        serialize={(value) => value}
        row
      />
    </Report>
  );
}

export default Relresumoturno;
